import React from 'react'
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../app/hooks';
import { getValueFromResource } from '../../../common/timeLiveFunction';

const UnverifiedPopup = ({ formik, setShowUnverifiedPopup, unverifiedEmails, onProceed  }: any) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const unverifiedEmailAddresses = [...formik.values.to, ...formik.values.cc, ...formik.values.bcc].filter(e => unverifiedEmails.has(e.toLowerCase()))
    return (
        <div>
            <div style={{ position: 'fixed', inset: 0, zIndex: 999999, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ background: '#fff', borderRadius: '10px', padding: '28px 32px', maxWidth: '440px', width: '90%', boxShadow: '0 8px 32px rgba(0,0,0,0.18)' }}>
                    <div style={{ textAlign: 'center', marginBottom: '5px' }}>
                        <i className="bi bi-exclamation-triangle-fill text-warning" style={{ fontSize: '50px' }} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center',justifyContent: 'center', gap: '10px', marginBottom: '14px' }}>
                        <h5 style={{ margin: 0, fontWeight: 700, color: 'black' }}>{ getValueFromResource('Unverified Emails Found', dispatch, t)}</h5>
                    </div>
                    <p style={{ color: '#555', fontSize: '14px', marginBottom: '10px' }}>
                        {unverifiedEmailAddresses?.length === 1 ? (
                            <>
                                The following email address is <strong>not verified</strong> in TimeLive. The report will <strong>not be delivered</strong> to this address.
                            </>
                        ) : (
                            <>
                                The following email addresses are <strong>not verified</strong> in TimeLive. The report will <strong>not be delivered</strong> to these addresses.
                            </>
                        )}
                    </p>
                    <ul style={{ paddingLeft: '18px', marginBottom: '18px' }}>
                        {unverifiedEmailAddresses?.map((email, i) => 
                        <li key={i} style={{ fontWeight: 600, fontSize: '13px' }}>
                            {email}
                        </li>
                        )}
                    </ul>
                    <p style={{ color: '#888', fontSize: '13px', marginBottom: '20px' }}>{ getValueFromResource('Do you want to proceed anyway?', dispatch, t)}</p>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                        <button className="btn btn-secondary btn-sm" onClick={() => setShowUnverifiedPopup(false)}>{ getValueFromResource('Cancel', dispatch, t)}</button>
                        <button className="btn btn-primary btn-sm" style={{ color: '#fff' }}onClick={() => { setShowUnverifiedPopup(false); onProceed(); }}>{ getValueFromResource('Proceed', dispatch, t)}</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UnverifiedPopup